define([
    'handlebars',
    'modules/common/controls/select2',
    'appcontext'
], (Handlebars, Select2, appContext) => Select2.extend({

    formatSelection (state) {
        const text = '#{0} {1}'.format(state.xid, _.escape(state.name));
        const tpl = state.enabled ? '<span>{0}</span>' : '<span class="muted">{0}</span>';
        return tpl.format(text);
    },

    formatResult (state) {
        let text;
        const tpl = state.enabled ? '<span>{0}</span>' : '<span class="muted">{0}</span>';
        if (_.isUndefined(state.children)) {
            text = '#{0} {1}'.format(state.xid, _.escape(state.name));
        } else if (this.options.withConnection) {
            text = appContext.tr('{0} (connection #{1}) #{2} {3}').format(
                Handlebars.helpers.h_wa_img(state.provider_id), state.connection_id, state.xid,
                _.escape(state.name)
            );
        } else {
            text = '{0} #{1} {2}'.format(
                Handlebars.helpers.h_wa_img(state.provider_id), state.xid, _.escape(state.name)
            );
        }
        return tpl.format(text);
    },

    matcher (term, text, option) {
        const pattern = term.toUpperCase();

        return option.id && option.name.toUpperCase().indexOf(pattern) >= 0 ||
                `${option.xid}`.indexOf(term) >= 0;
    }

}));
